var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 265.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffcb05;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.26,227.35c-.34-2.87-.34-10.01,0-12.88.47-3.88,3.34-10.83,5.17-14.44C42.61,138.64,78.58,76.43,116.42,15.48c19.32-22.05,53.12-20.31,70.08,3.68l108.23,180.87c14.37,26.82-2.07,60.04-32.15,64.61-74.73,1.3-149.76,1.12-224.5.09-18.26-1.87-35.67-19.27-37.82-37.39ZM147.02,17.99c-7.75.85-14.89,5.45-19.07,11.95L21.32,208.32c-9.28,17.12,1.97,37.43,21.34,38.94h214.82c19.19-1.5,30.45-21.46,21.56-38.57L171.97,29.59c-5.44-8.22-15.11-12.68-24.95-11.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.44,54.28c15.03-1.82,28.14,8.57,30,23.52-1.16,18.84,1.47,39.35,0,57.98-2.46,31.21-49.11,31.71-52.71.59,1.27-18.93-1.62-39.89,0-58.57,1.01-11.61,11.14-22.12,22.72-23.52ZM156.32,139.36c1.27-1.27,2.35-4.14,2.54-5.94-1.48-16.71,2-36.9-.07-53.19-1.39-10.94-16.32-10.97-17.48.53-1.69,16.71,1.21,36.19.04,53.2.81,7.18,9.78,10.6,14.96,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.44,177.18c32.04-3.86,41.66,41.26,12.57,51.19-37.56,12.82-49.53-46.74-12.57-51.19ZM156.32,209.59c7.8-7.8-4-19.85-12.12-12.41-8.68,7.95,4.05,20.47,12.12,12.41Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.44d137777078e95d25ebf49c6574aae2.svg";
export { ForwardRef as ReactComponent };